var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.user.id == null || _vm.$store.state.token == null)?_c('Login'):_c('div',{staticClass:"d-flex w-100"},[_c('Sidebar'),_c('Content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }